import { Maybe, ScanSessionResultsInsights, SideGaitResultsInsights } from '@/common/types';

export const resultsInsightsAreSideGait = (
    resultsInsights: Maybe<ScanSessionResultsInsights>,
): resultsInsights is SideGaitResultsInsights => {
    return (resultsInsights as SideGaitResultsInsights).lapInfo !== undefined;
};
